<template>
  <div class="container">
    <div class="line-1e1"></div>
    <div class="filterView">
      <div
        :class="[item.type != 'custom' ? (current == item.type ? 'filterItem activeItem' : 'filterItem normalItem') : (isCustom ? 'activeCustomItem' : 'normalCustomItem')]"
        v-for="(item,index) in filterList"
        :key="`filter-${index}`"
        @click.stop="handleSelect(item)"
      >
        {{item.title}}
      </div>
    </div>
    <div v-if="isCustom && customTimeList.length > 0" class="width100">
      <div class="customView">
        <div :class="['customItem ',index < customTimeList.length - 1 ? 'm-r-8' : '']" v-for="(item,index) in customTimeList" :key="`time-${index}`">
          <div class="timeItem">{{item}}</div>
          <img src="@/assets/image/statisticManage/clear@3x.png" class="imgView48" @click.stop="handleClear(index)"/>
        </div>
      </div>
    </div>
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
    >
      <van-list
        class="listView"
        v-model="loading"
        :finished="finished"
        :error="error"
        finished-text="没有更多信息了～"
        error-text="数据加载失败，请重试"
        @load="onLoad"
      >
      <div class="gridList">
        <div v-for="(item,index) in headList" :key="`head-${index}`" :class="['headItem ',index > 0 ? 'jus-center' : '']">
          {{`${item.type == 'date' ? `${item.title}(${year}年-${currentFilter.showText})` : item.title}`}}
        </div>
        <div
          v-for="(item,index) in totalList"
          :key="`total-${index}`"
          :class="['totalItem ',index > 0 ? 'jus-center' : '',item.prop == 'rqrs' ? 'c554 bold' : item.prop == 'tqrs' ? 'c18a bold' : '']"
        >
          {{item.title ? item.title : totalInfo[item.prop]}}
        </div>
      </div>
      <div class="gridList" v-for="(item,index) in list" :key="`list-${index}`">
        <div class="listItem">{{formatShowText(item)}}</div>
        <div class="listItem c554 bold jus-center">{{item.rqrs}}</div>
        <div class="listItem c18a bold jus-center">{{item.tqrs}}</div>
      </div>
      </van-list>
    </van-pull-refresh>
    <!-- 选择日期区间(日维度)-->
    <van-calendar
      v-model="showTime"
      allow-same-day
      type="range"
      color="#1989fa"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="onTimeConfirm"
      @opened="calendarOpened"
    />
    <!-- 选择日期区间(月/周维度)-->
    <customCalender
      :show="showCustomCalender"
      allow-same-time
      :type="current"
      :span="current == 'month' ? 6 : 4"
      @confirm="handleCustomCalenderConfirm"
      @close="handleCustomCalenderClose"
    ></customCalender>
  </div>
</template>

<script>
import utils from "@/utils/common";
import customCalender from "../../components/customCalender.vue";
import http from "@/utils/axios";
import moment from "moment";

export default ({
  components:{
    customCalender
  },
  props:{
    groupId:{
      type:String,
      default:() => {
        return ''
      }
    }
  },
  data() {
    return {
      list:[],
      queryData:{},
      minDate: new Date(new Date().getFullYear()-1, 0, 1),
      maxDate: new Date(new Date()),
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      filterList:[
        {
          type:'day',
          title:'日维度',
          showText:'日',
          value: 0
        },
        {
          type:'week',
          title:'周维度',
          showText:'周',
          value: 1
        },
        {
          type:'month',
          title:'月维度',
          showText:'月',
          value: 2
        },
        {
          type:'custom',
          title:'自定义',
          value: 3
        }
      ],
      current:'day',
      currentFilter:{},
      isCustom:false,
      customTimeList:[],
      customeTime:`${new Date().getFullYear()}/01/01-${new Date().getFullYear()}/12/31`,
      headList:[
        {
          prop:'days',
          title:'日期',
          type:'date'
        },
        {
          prop:'rqrs',
          title:'添加人数'
        },
        {
          prop:'tqrs',
          title:'流失人数'
        }
      ],
      totalList:[
        {
          prop:'',
          title:'合计'
        },
        {
          prop:'tjrshz',
        },
        {
          prop:'lsrshz',
        }
      ],
      totalInfo:{},
      showTime:false,
      showCustomCalender:false,
      year: new Date().getFullYear()
    }
  },
  created() {
    // this.$loading.hide();
    // this.getList()
    this.currentFilter = this.filterList[0]
  },
  mounted() {

  },
  methods:{
    formatShowText(item){
      if(this.currentFilter.value == 0){ // 日
        return item.days
      }else if(this.currentFilter.value == 1){ // 周
        let week = Number(item.days.split('-')[1])
        let start = item.dayStart.replace(/\-/g, '/')
        let end = item.dayEnd.replace(/\-/g, '/')
        return `第${week}周(${moment(start).format('MM/DD')}-${moment(end).format('MM/DD')})`
      }else if(this.currentFilter.value == 2){ // 月
        let month = Number(item.days.split('-')[1])
        let start = item.dayStart.replace(/\-/g, '/')
        let end = item.dayEnd.replace(/\-/g, '/')
        return `${month}月(${moment(start).format('MM/DD')}-${moment(end).format('MM/DD')})`
      }
    },
    /**
     * 打开日历后
     * */
     calendarOpened(){
      let initTop = document.querySelector('.van-calendar__body').scrollTop
      document.querySelector('.van-calendar__body').scrollTop = initTop - 1
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.refreshing = true
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.error = false;
      this.page = 1
      this.total = 0
      this.onLoad();
    },
    // 列表加载数据
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.totalInfo = {}
        this.refreshing = false;
      }
      if (this.list.length > 0 && this.list.length >= this.total) {
        this.finished = true
        return
      }
      this.getDataList()
    },
    /**
     * 查询业绩信息
     * */
    getDataList(){
      this.$loading.hide()
      this.loading = true
      let param = {
        daysType: this.currentFilter.value,
        groupId: this.groupId
      }
      if(!utils.isNullData(this.customeTime)){
        param.startTime = moment(this.customeTime.split('-')[0]).format('YYYY-MM-DD')
        param.endTime = moment(this.customeTime.split('-')[1]).format(('YYYY-MM-DD'))
      }
      http({
        url: "order/dmp/dispatch/memberpush/BsEnterpriseWechatGroupChat/findMemInfoForTime",
        method: "post",
        parmes: {
          ...param,
          pageIndex:this.page,
          pageSize:this.pageSize
        }
      }).then(rps => {
        if (rps.code == 200) {
          let data = rps.data;
          this.totalInfo = data
          this.list = this.list.concat(data.bsEnterpriseWechatGroupChatMemberTqOrRqVos);
          if(this.list.length > 0){
            this.year = this.list[0].days.split('-')[0]
          }
          this.page++
          this.total = data.total ? data.total : this.list.length
          this.loading = false;
          if (this.list.length >= this.total) {
            this.finished = true;
          }
        }else{
          this.loading = false;
          this.error = true;
          this.$toast('请求异常，请稍后重试')
        }
        this.$loading.hide();
      }).catch(() => {
        this.$loading.hide();
        this.loading = false;
        this.error = true;
        this.$toast('请求失败，请稍后重试')
      });
      // this.list = [
      //   {
      //     date:'6月（06/01-06/30）',
      //     addCount:100,
      //     subCount:50
      //   },
      //   {
      //     date:'6月（06/01-06/30）',
      //     addCount:200,
      //     subCount:50
      //   }
      // ]
    },
    /**
     * 格式化数据
     */
    getTransformData(data, defaultValue = '') {
      if (utils.isNullData(data)) {
        return defaultValue
      }
      return data;
    },
    // 选择查询维度
    handleSelect(item){
      if(item.type == 'custom'){
        this.customTimeList = []
        this.isCustom = true
        if(this.current == 'day'){
          this.showTime = true
        }else if(this.current == 'week' || this.current == 'month'){
          this.showCustomCalender = true
        }
      }else{
        this.current = item.type
        this.currentFilter = item
        this.isCustom = false
        this.customTimeList = []
        this.customeTime = `${new Date().getFullYear()}/01/01-${new Date().getFullYear()}/12/31`
        this.list = []
        this.totalInfo = {}
        this.onRefresh()
        // if(this.current == 'week'){
        //   let weekDate = utils.getWeekRangeDateByCurrentDate()
        //   this.customeTime = `${this.formatDate(weekDate.start)}-${this.formatDate(weekDate.end)}`
        // }else if(this.current == 'month'){
        //   let weekDate = utils.getMonthRangeDateByCurrentDate()
        //   this.customeTime = `${this.formatDate(weekDate.start)}-${this.formatDate(weekDate.end)}`
        // }
      }
    },
    /**
     * 选择时间确认(日维度)
     * */
    onTimeConfirm(date){
      const [start, end] = date;
      this.showTime = false;
      let customeTime = `${this.formatDate(start)} - ${this.formatDate(end)}`;
      // if(this.customTimeList.indexOf(customeTime) < 0){
      //   this.customTimeList.push(customeTime)
      // }
      this.customTimeList = [customeTime]
      this.customeTime = customeTime
      this.list = []
      this.totalInfo = {}
      this.onRefresh()
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    handleClear(index){
      this.customTimeList.splice(index,1)
      this.customeTime = `${new Date().getFullYear()}/01/01-${new Date().getFullYear()}/12/31`
      this.list = []
      this.totalInfo = {}
      this.onRefresh()
    },
    /**
     * 月、周维度弹窗确认
     */
    handleCustomCalenderConfirm(range,dateStr){
      this.showCustomCalender = false
      this.customeTime = `${range[0].start}-${range[1].end}`
      if(this.customTimeList.indexOf(dateStr) < 0){
        // this.customTimeList = [dateStr]
        this.customTimeList = [this.customeTime]
      }
      this.list = []
      this.totalInfo = {}
      this.onRefresh()
    },
    handleCustomCalenderClose(){
      this.showCustomCalender = false
    }
  }
})
</script>
<style lang="less" scoped>
@import url("../../style/index.css");
.container {
  width: 100%;
  .line-1e1 {
    width: 100%;
    position: relative;
    height: 1px;

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      content: ' ';
      width: 200%;
      height: 200%;
      background: #E1E1E1;
      transform-origin: 0 0;
      transform: scale(0.5);
    }
  }
  .filterView{
    padding: 12px 32px;
    // display: flex;
    // align-items: center;
    // justify-content: space-between;
    display: grid;
    grid-template-columns: repeat(4,auto);
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    background: #FFFFFF;
    flex-wrap: wrap;
    .filterItem{
      flex-shrink: 0;
      border-radius: 8px;
      // padding: 11px 44px;
      padding: 11px 0;
      // width: calc(calc(100% - 24px)/3);
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      font-weight: 400;
      line-height: 33px;
    }
    .normalItem{
      color: #62615F;
      background: #F6F6F6;
      border: 2px solid #F6F6F6;
    }
    .activeItem{
      color: #4466F5;
      background: rgba(68,102,245,0.1);
      border: 2px solid #4466F5;
    }
    .normalCustomItem{
      flex-shrink: 0;
      background: #FFFFFF;
      box-shadow: 0px 2px 8px 0px rgba(216,220,230,0.5);
      border-radius: 8px;
      font-size: 24px;
      font-weight: 400;
      color: #62615F;
      line-height: 33px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 11px 0;
      // width:160px;
      // width: calc(calc(100% - 24px)/3);
      text-align: center;
    }
    .activeCustomItem{
      background: #4466F5;
      border-radius: 8px;
      font-size: 24px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 33px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 11px 0;
    }
  }
  .customView{
    padding: 12px 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .customItem{
      background: #FFFAE6;
      border-radius: 24px 100px 100px 0px;
      padding: 0 13px 0 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .timeItem{
        font-size: 22px;
        font-weight: 400;
        color: #F08E3C;
        line-height: 28px;
        margin-right: 12px;
      }
    }
  }
  .gridList{
    display: grid;
    grid-template-columns: 40% 30% 30%;
    grid-column-gap: 0;
    grid-row-gap: 0;
    background: #FFFFFF;
    .headItem{
      padding: 19px 24px;
      display: flex;
      align-items: center;
      font-size: 26px;
      font-weight: 400;
      color: #898887;
      line-height: 34px;
    }
    .totalItem{
      background: rgba(68,102,245,0.06);
      padding: 19px 24px;
      display: flex;
      align-items: center;
      font-size: 26px;
      font-weight: 400;
      color: #62615F;
      line-height: 34px;
    }
    .listItem{
      padding: 19px 24px;
      display: flex;
      align-items: center;
      font-size: 24px;
      font-weight: 400;
      color: #62615F;
      line-height: 34px;
    }
  }
}
</style>
